"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ControlLabel["default"];
  }
});
var _ControlLabel = _interopRequireDefault(require("react-bootstrap/lib/ControlLabel"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/ControlLabel.js
// module id = 6394
// module chunks = 25